import { path } from 'ramda'
import { defaultState, createURL } from '../../utils'
import { getFilterBy, getNextState } from '../../SearchFilters/LocationFilter/utils'

export const onSearchSubmit = (history, { keywordsInputVal, locationValue }) => {
  const type = path(['type'], locationValue)
  const filter = getFilterBy(type)

  let locationState = {}

  if (filter) {
    const filterState = filter(locationValue)
    locationState = getNextState({}, filterState, type)
  }

  const searchState = { ...defaultState, ...locationState, query: keywordsInputVal.trim() }
  const url = `/search${createURL(searchState)}`

  history.push(
    url,
    searchState
  )
}
